import { PART_TAG_REGEX } from "../../constants/regex";

export default (value) => value && String(value).match(PART_TAG_REGEX);
